<template>
    <ul @scroll="handleScroll" ref="list">
        <li v-for="(option, index) in optionsList" :key="option[idField]"
            :class="{ action: option.action }"
            @click="handleOptionClick(option)">
            <div class="preset-element"
                 :class="{'selected-preset font-4' : selectedItem === option,
                          'font-7': !selectedItem === option,
                          'bold': markSelected && selectedItem === option,
                          'header font-8': option.isHeader,
                          'active': activeIndex === index,
                          'disable-preset': option.disabled }">
                <slot :option="option" name="preOption"></slot>
                <span class="truncate">
                    <slot :option="option" name="preOptionInner"></slot>
                   {{option[displayField]}}
                </span>
                <slot :option="option" name="postOption"></slot>
            </div>
            <div class="description" v-if="option.description" v-once>
                <slot :option="option" name="description">
                    <div class="dropdown-item-description-container">
                        <div class="font-4 dropdown-item-description-title">
                            {{option.titleText}}
                        </div>
                        <div>
                            {{option.description}}
                        </div>
                    </div>
                </slot>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'LeavesDropdown',
    props: {
        idField: String,
        options: Array,
        selectedItem: Object,
        displayField: String,
        markSelected: Boolean,
        lazyRender: Boolean,
        activeIndex: Number
    },
    data() {
        return {
            currentMax: 25
        };
    },
    computed: {
        optionsList() {
            return this.lazyRender ? this.lazyOptions : this.options;
        },
        lazyOptions() {
            return this.options.slice(0, this.currentMax);
        }
    },
    methods: {
        callAction(option) {
            option.action();
            this.$emit('closeMenu');
        },
        handleOptionClick(option) {
            if (option.disabled || option.isHeader) {
                return;
            }
            if (option.action) {
                this.callAction(option);
            } else {
                this.$emit('dropdownSelectedOption', option);
            }
        },
        handleScroll() {
            const { scrollHeight, offsetHeight, scrollTop } = this.$refs.list;
            if (scrollHeight - offsetHeight - scrollTop <= 100) {
                this.currentMax = Math.min(this.options.length, this.currentMax + 25);
            }
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";
    @import './dropdownStyleGuide';

    $paddingLeftElements: 20px;

    li {
        position: inherit;
    }

    li:not(:last-child) {
        border-bottom: $border;
    }

    .preset-element {
        .truncate {
            display: block;
        }

        overflow: hidden;
        position: relative;
        padding-left: $paddingLeftElements;
        padding-right: $paddingLeftElements;
        white-space: nowrap;
        display: block;
        line-height: 40px;
        cursor: pointer;
        color: $dark-300;

        &:hover, &.active {
            background-color: $light-100;
        }

        &.disable-preset {
            cursor: default;
            color: $light-800;
            &:hover {
                background: inherit;
            }
        }

        &.header {
            margin-left: -10px;
            cursor: default;
            color: $light-800;
            &:hover, &.active {
                background: inherit;
            }
        }
    }

    .selected-preset, .selected-preset:hover, .selected-preset.hover {
        background: $light-100;

        &:before {
            border-left: 2px solid $selectedColor;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
        }
    }

    .dropdown-item-description-container {
        padding: 10px 15px 5px;
    }

    .dropdown-item-description-title {
        margin-bottom: 10px;
    }

    .bold.selected-preset, .bold.selected-preset:hover, .bold.selected-preset.hover {
        &:before {
            border-left: 4px solid $selectedColor;
        }
    }
</style>
